import React from 'react';

import AppStore from '../ui/app-store';

import Button from '../ui/button';

import { Icons } from '../ui/icons';

const AppExclusive = ({ data }) => {
  return (
    <div className="m-9 flex flex-col gap-10">
      <Button className="flex cursor-not-allowed flex-row gap-2">
        APP EXCLUSIVE <Icons.Padlock />
      </Button>
      <div className="flex flex-row items-center justify-between gap-4 px-4 lg:w-11/12 lg:flex-col lg:items-start lg:px-0">
        <div className="min-w-fit">
          <p className="!m-0 text-sm lg:inline-block">
            <b>Download our app</b>
          </p>{' '}
          <p className="!m-0 text-sm lg:inline-block">to purchase this item.</p>
        </div>
        <div className="w-full flex-row gap-3 lg:flex">
          <AppStore />
        </div>
      </div>
      <div className="grid w-full grid-cols-1 gap-3 lg:w-10/12 lg:grid-cols-2">
        <div className="hidden lg:block">
          <div className="flex w-full flex-col gap-3 rounded-lg bg-[#DFFDF9] px-5 py-4 lg:px-3">
            <p className="!m-0 text-xs">
              <b>Need our app?</b>
            </p>
            <p className="!m-0 text-xs">Scan to download our app.</p>
            <Icons.QrCode />
          </div>
        </div>
        <div className="flex w-full flex-col gap-3 rounded-lg bg-[#DFFDF9] px-5 py-4 lg:px-3">
          <p className="!m-0 pl-3 text-sm lg:pl-0 lg:text-xs">
            <b>Already have our app?</b>
          </p>
          <p className="!m-0 hidden text-xs lg:inline-block">
            Scan to open this product in our app
          </p>
          <div className="rounded bg-white p-3 lg:hidden">
            <p className="!m-0 text-sm">
              <b>Click here</b> to view this item in our app.
            </p>
          </div>
          <p className="!m-0 pl-3 text-xs text-[#83A19D] lg:hidden">
            If this link doesn&apos;t work, search for the item in our app.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AppExclusive;
